export default "__VITE_ASSET__bea47e0c__"